import { Theme } from '@mui/material/styles'

// ----------------------------------------------------------------------

export default function ControlLabel(theme: Theme) {
  return {
    MuiFormControlLabel: {
      styleOverrides: {
        label: {
          ...theme.typography.body2,
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          marginTop: theme.spacing(1),
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          // The third ink, not the disabled one: a field's label is content the reader has to read,
          // and `text.disabled` put it at 2.98:1 in light mode and 2.70:1 in dark. Tertiary is still
          // the quietest step in the ramp — the label keeps whispering next to its value — but it
          // clears 5.4:1 in both modes.
          color: theme.palette.text.tertiary,
        },
      },
    },
  }
}
